import apiClient from "../../client/api-client";
import { endpoints } from "../../api";

export const getDashboardStats = () =>
  apiClient({ url: endpoints.DASHBOARD_STATS, method: "GET" });

export const getUserList = (params) =>
  apiClient({ url: endpoints.USER_LIST, method: "GET", params });

export const getUserDetail = (id) =>
  apiClient({ url: endpoints.USER_DETAIL(id), method: "GET" });

export const toggleUserStatus = (id) =>
  apiClient({ url: endpoints.USER_TOGGLE_STATUS(id), method: "PATCH" });

export const deleteUser = (id) =>
  apiClient({ url: endpoints.USER_DELETE(id), method: "DELETE" });

// Contact Inquiries
export const getInquiryList = (params) =>
  apiClient({ url: endpoints.INQUIRY_LIST, method: "GET", params });

export const updateInquiryStatus = (id, eStatus) =>
  apiClient({ url: endpoints.INQUIRY_UPDATE_STATUS(id), method: "PATCH", data: { eStatus } });

export const replyToInquiry = (id, sReply) =>
  apiClient({ url: endpoints.INQUIRY_REPLY(id), method: "POST", data: { sReply } });

// FAQs
export const getFaqList = (params) =>
  apiClient({ url: endpoints.FAQ_LIST, method: "GET", params });

export const createFaq = (data) =>
  apiClient({ url: endpoints.FAQ_CREATE, method: "POST", data });

export const updateFaq = (id, data) =>
  apiClient({ url: endpoints.FAQ_UPDATE(id), method: "PATCH", data });

export const deleteFaq = (id) =>
  apiClient({ url: endpoints.FAQ_DELETE(id), method: "DELETE" });

// CMS
export const getCmsList = () =>
  apiClient({ url: endpoints.CMS_LIST, method: "GET" });

export const getCmsById = (id) =>
  apiClient({ url: endpoints.CMS_GET(id), method: "GET" });

export const updateCmsContent = (data) =>
  apiClient({ url: endpoints.CMS_UPDATE, method: "PATCH", data });

// Features
export const getFeatureList = (params) =>
  apiClient({ url: endpoints.FEATURE_LIST, method: "GET", params });

export const createFeature = (data) =>
  apiClient({ url: endpoints.FEATURE_CREATE, method: "POST", data });

export const updateFeature = (id, data) =>
  apiClient({ url: endpoints.FEATURE_UPDATE(id), method: "PATCH", data });

export const deleteFeature = (id) =>
  apiClient({ url: endpoints.FEATURE_DELETE(id), method: "DELETE" });

// News Articles
export const getNewsList = (params) =>
  apiClient({ url: endpoints.NEWS_LIST, method: "GET", params });

export const createNews = (data) =>
  apiClient({ url: endpoints.NEWS_CREATE, method: "POST", data });

export const updateNews = (id, data) =>
  apiClient({ url: endpoints.NEWS_UPDATE(id), method: "PATCH", data });

export const deleteNews = (id) =>
  apiClient({ url: endpoints.NEWS_DELETE(id), method: "DELETE" });

// User Inquiries (user-facing)
export const submitInquiry = (data) =>
  apiClient({ url: endpoints.USER_SUBMIT_INQUIRY, method: "POST", data });

export const getMyInquiries = (params) =>
  apiClient({ url: endpoints.USER_INQUIRY_LIST, method: "GET", params });
